import Vue from 'vue';
import moment from 'moment'
// 定义和配置各种过滤器
Vue.filter('money', function (val, currency) {
  if (typeof val === 'undefined' || val === null || val === '') {
    return '';
  }
  return '' + (currency === undefined ? '¥' : currency) + parseFloat(val).toFixed(2)
});
Vue.filter('inMoney', function (val, currency) {
  if (typeof val === 'undefined' || val === null || val === '') {
    return '';
  }
  return '' + (currency === undefined ? '+' : currency) + parseFloat(val).toFixed(2)
});
Vue.filter('outMoney', function (val, currency) {
  if (typeof val === 'undefined' || val === null || val === '') {
    return '';
  }
  return '' + (currency === undefined ? '-' : currency) + parseFloat(val).toFixed(2)
});

Vue.filter('accountRemark', function (val) {
  // 备注信息：1、股东；2、店长；3、店员；4、供应商；5、门店房东；6、其他
  let remark = { 1: '股东', 2: '店长', 3: '店员', 4: '供应商', 5: '门店房东', 6: '其他' };
  return remark[val] || '-';
})

Vue.filter('transferBizType', function (val) {
  // 业务转账类型（交易描述）0:发工资  1:报销  2:水电租金  3:股东分红  4:其他
  let bizType = { 0: '发工资', 1: '报销', 2: '水电租金', 3: '股东分红', 4: '其他' };
  return bizType[val] || '-';
});

Vue.filter('transferOrderStatus', function (val) {
  // 订单状态 ( ACCEPT_SUCC：受理成功,PAY_SUCC：成功,PAY_ING：处理中,PAY_FAIL：失败)
  let transferStatus = { 'ACCEPT_SUCC': '受理成功', 'PAY_SUCC': '成功', 'PAY_ING': '处理中', 'PAY_FAIL': '失败' };
  return transferStatus[val] || '-';
})

Vue.filter('transferCheckStatus', function (val) {
  // 审核状态 0 待发起 1 待审核；2 审核成功 ；3 审核拒绝
  let auditStatus = { 0: '待发起', 1: '待审核', 2: '审核成功', 3: '审核拒绝' };
  return auditStatus[val] || '-';
})

Vue.filter('moneyFilter', function (num) {
  if (typeof num === 'undefined' || num === null || num === '') {
    return ''
  } else if (num === 0) {
    return num + '.00'
  } else {
    return parseFloat(num).toFixed(2);
  }
});

Vue.filter('moneyFilter1', function (num) {
  if (num) {
    if (!isNaN(num) && typeof num === 'number') {
      return num.toFixed(2).toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    } else {
      return parseFloat(num).toFixed(2).toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    }
  } else if (typeof num === 'undefined' || num === null || num === '') {
    return ''
  } else if (num === 0) {
    return num + '.00'
  }
});

Vue.filter('moneyToUpper', function (val) {
  let fraction = ['角', '分'];
  let digit = [
    '零', '壹', '贰', '叁', '肆',
    '伍', '陆', '柒', '捌', '玖'
  ];
  let unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ];
  let head = val < 0 ? '欠' : '';
  val = Math.abs(val);
  let s = '';
  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(Math.floor(val * 1000 * 10 * Math.pow(10, i)) % (10 * 1000) / 1000)] + fraction[i]).replace(/零./, '')
  }
  s = s || '整';
  val = Math.floor(val);
  for (let i = 0; i < unit[0].length && val > 0; i++) {
    let p = '';
    for (let j = 0; j < unit[1].length && val > 0; j++) {
      p = digit[val % 10] + unit[1][j] + p;
      val = Math.floor(val / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return head + s.replace(/(零.)*零元/, '元')
    .replace(/(零.)+/g, '零')
    .replace(/^整$/, '零元整');
});

Vue.filter('formatImageSize', function (imageUrl, size, heightSize) {
  if (typeof imageUrl === 'undefined' || imageUrl === null || imageUrl === '') {
    return '';
  }
  // 图片
  if (matchType(imageUrl) === 'image') {
    if (undefined === heightSize) {
      heightSize = size;
    }
    if (imageUrl.indexOf('alioss') > 0) {
      return imageUrl + `?x-oss-process=image/resize,m_pad,h_${heightSize},w_${size},color_FFFFFF`;
    } else {
      return imageUrl + `?imageView2/2/w/${size}/h/${heightSize}`;
    }
  } else if (matchType(imageUrl) === 'video') {
    // 取1秒的截图，宽：size，高：heightSize
    return imageUrl + '?vframe/jpg/offset/1/w/' + size + '/h/' + heightSize;
  }
});

Vue.filter('formatDateTime', function (val, format) {
  if (val) {
    return moment(val).format(format || 'YYYY-MM-DD');
  }
  return '-';
});
Vue.filter('formatDateTime1', function (val, format) {
  if (val) {
    return moment(val).format(format || 'YYYY/MM/DD');
  }
  return '-';
});

Vue.filter('rakeTwo', function (val) {
  if (typeof val === 'undefined' || val === null || val === '') {
    return '';
  }
  return val.toFixed(2);
});

Vue.filter('moneyToUpper', function (val) {
  let fraction = ['角', '分'];
  let digit = [
    '零', '壹', '贰', '叁', '肆',
    '伍', '陆', '柒', '捌', '玖'
  ];
  let unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ];
  let head = val < 0 ? '欠' : '';
  val = Math.abs(val);
  let s = '';
  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(Math.floor(val * 1000 * 10 * Math.pow(10, i)) % (10 * 1000) / 1000)] + fraction[i]).replace(/零./, '')
  }
  s = s || '整';
  val = Math.floor(val);
  for (let i = 0; i < unit[0].length && val > 0; i++) {
    let p = '';
    for (let j = 0; j < unit[1].length && val > 0; j++) {
      p = digit[val % 10] + unit[1][j] + p;
      val = Math.floor(val / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return head + s.replace(/(零.)*零元/, '元')
    .replace(/(零.)+/g, '零')
    .replace(/^整$/, '零元整');
});

function matchType (fileName) {
  // 后缀获取
  var suffix = '';
  // 获取类型结果
  var result = '';
  try {
    var flieArr = fileName.split('.');
    suffix = flieArr[flieArr.length - 1];
  } catch (err) {
    suffix = '';
  }
  // fileName无后缀返回 false
  if (!suffix) {
    result = false;
    return result;
  }
  // 图片格式
  var imglist = ['jpg', 'JPG', 'png', 'PNG', 'jpeg', 'JPEG', 'gif', 'GIF', 'bmp', 'BMP', 'svg', 'SVG'];
  // 进行图片匹配
  result = imglist.some(function (item) {
    return item === suffix;
  });
  if (result) {
    result = 'image';
    return result;
  };
  // 匹配 视频
  var videolist = ['avi', 'rmvb', 'rm', 'asf', 'divx', 'mpg', 'mpeg', 'mpe', 'wmv', 'mp4', 'mkv', 'vob'];
  result = videolist.some(function (item) {
    return item === suffix;
  });
  if (result) {
    result = 'video';
    return result;
  };
  // 其他 文件类型
  result = 'other';
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/filters.js